import { render, staticRenderFns } from "./entities.vue?vue&type=template&id=50de7d7a&"
import script from "./entities.vue?vue&type=script&lang=js&"
export * from "./entities.vue?vue&type=script&lang=js&"
import style0 from "./entities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports